import { useEffect } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, useLocation } from "react-router-dom";
import { appendAnalytics } from "utils/adobeAnalytics";
import { updateSalesforceChatPrechatFields } from "utils/salesforceChat";
import { AppProvider } from "context/AppContext";
import Layout from "components/Layout/Layout";
import MyProfile from "pages/MyProfile";

const RouteSideEffects = () => {
    const location = useLocation();

    useEffect(() => {
        updateSalesforceChatPrechatFields(location.pathname);
    }, [location.pathname]);

    return null;
};

const App = ({ user }) => {
    useEffect(() => {
        appendAnalytics();
    }, []);

    return (
        <AppProvider user={user}>
            <Router basename={process.env.PUBLIC_URL}>
                <RouteSideEffects />
                <Layout>
                    <Route path={["/", ""]} component={MyProfile} />
                </Layout>
            </Router>
        </AppProvider>
    );
};

App.propTypes = {
    user: PropTypes.object
};

export default App;
